import { useState } from "react";
import { DOC_TIPOS, paisNombre } from "../../lib/kycData";
import { BigButton, GhostButton, StepTitle } from "./KycShell";

const fecha = (iso) => (iso ? iso.split("-").reverse().join("/") : "—");
const tipoDoc = (d) => (d.documento_tipo === "otro" ? d.documento_otro : DOC_TIPOS.find(([v]) => v === d.documento_tipo)?.[1]);
const SEXO = { F: "Femenino", M: "Masculino" };

const filas = (d) => [
  ["Nombres", d.nombres],
  ["Apellidos", [d.apellido_paterno, d.apellido_materno].filter(Boolean).join(" ")],
  ["Documento", tipoDoc(d)],
  ["Número", d.documento_numero],
  ["Nacionalidad", paisNombre(d.nacionalidad)],
  ["Fecha de nacimiento", fecha(d.fecha_nacimiento)],
  ["Vence", fecha(d.documento_vencimiento)],
  ["Sexo", SEXO[d.sexo] || "—"],
];

export const StepConfirmar = ({ brand, datos, onSubmit, busy, paso }) => {
  const [error, setError] = useState(false);
  const [obs, setObs] = useState("");
  return (
    <div className="space-y-5" data-testid="kyc-step-confirmar">
      <StepTitle paso={paso} title="¿Estos son tus datos?">Los leímos de tu documento.</StepTitle>
      <dl className="bg-white border border-slate-200 rounded-xl divide-y" data-testid="kyc-datos-leidos">
        {filas(datos).map(([k, v]) => (
          <div key={k} className="flex justify-between gap-4 p-3 text-base">
            <dt className="text-slate-500">{k}</dt>
            <dd className="font-semibold text-right" data-testid={`kyc-leido-${k.toLowerCase().replaceAll(" ", "-")}`}>{v || "—"}</dd>
          </div>
        ))}
      </dl>
      {!error ? (
        <>
          <BigButton color={brand.color} disabled={busy} onClick={() => onSubmit({ hay_error: false })} data-testid="confirmar-datos-si">Sí, son mis datos</BigButton>
          <GhostButton disabled={busy} onClick={() => setError(true)} data-testid="confirmar-datos-error">Hay un error</GhostButton>
        </>
      ) : (
        <div className="space-y-3" data-testid="kyc-observacion">
          <label htmlFor="observacion" className="block text-base font-medium">¿Qué dato está mal y cuál es el correcto?</label>
          <textarea id="observacion" rows={3} maxLength={500} value={obs} onChange={(e) => setObs(e.target.value)}
            className="w-full rounded-lg border-2 border-slate-300 p-3 text-base focus:border-slate-900 focus:outline-none" data-testid="kyc-observacion-input" />
          <p className="text-sm text-slate-500">La empresa revisará tu documento. No podemos cambiar aquí los datos leídos.</p>
          <BigButton color={brand.color} disabled={busy || obs.trim().length < 5} onClick={() => onSubmit({ hay_error: true, observacion: obs.trim() })} data-testid="kyc-observacion-enviar">Enviar y continuar</BigButton>
          <GhostButton disabled={busy} onClick={() => setError(false)} data-testid="kyc-observacion-cancelar">Volver</GhostButton>
        </div>
      )}
    </div>
  );
};
